import { cameraStreamManager } from 'services/CameraStream/CameraStreamManager';
import { beforeUnloadHandler } from 'utils/beforeunloadHandler';

export function find3CXExtension(camsConfig) {
    const cameras = [...(camsConfig?.level1 || []), ...(camsConfig?.level2 || [])];
    return cameras.find((camera) => camera?.status !== 'INACTIVE' && camera?.extensionNumber3CX)?.extensionNumber3CX || null;
}

export function start3CXCall(extension) {
    if (!extension) return;

    window.removeEventListener('beforeunload', beforeUnloadHandler);
    cameraStreamManager.removeBeforeUnloadListener();
    try {
        window.open(`tel:${String(extension).padEnd(6, '-')}`, '_self');
    } finally {
        cameraStreamManager.setBeforeUnloadListener();
        window.addEventListener('beforeunload', beforeUnloadHandler);
    }
}
